<template>
  <div id="layout-footer">
    <div class="footer-main">
      <div class="footer-item">
        <div class="footer-item-title">相关链接</div>
        <div>
          <a target="_blank" class="out-link" :href="this.$store.state.authConfig.github">
            <i class="iconfont icon-github"></i> GitHub
          </a>
        </div>
        <div>
          <a target="_blank" class="out-link" :href="this.$store.state.authConfig.gitee">
            <i class="iconfont icon-gitee"></i> Gitee
          </a>
        </div>
      </div>
      <div class="footer-item footer-center">
        <div class="footer-logo">{{ this.$store.state.webConfig.name }}</div>
        <div class="footer-slogan">一个热爱技术的博主</div>
      </div>
      <div class="footer-item">
        <div><i class="iconfont icon-shijian"></i> 已运行 <em class="run-time">{{ this.$store.state.runTimeInterval }}</em></div>
        <div><i class="el-icon-user"></i> 在线 <em class="online-count">{{ this.$store.state.onlinePerson }}</em> 人</div>
        <div>
          <a target="_blank" class="out-link" :href="this.$store.state.webConfig.managementUrl">☞ 后台管理</a>
        </div>
      </div>
    </div>
    <div class="footer-divider"></div>
    <div class="copyright">
      Copyright &copy; {{ this.$store.state.runTimeYear }}
      <a target="_blank" class="out-link" :href="this.$store.state.webConfig.webUrl">qiangesoft.cn</a>
      All Rights Reserved &nbsp;|
      <a target="_blank" class="out-link" href="https://beian.miit.gov.cn/">{{ this.$store.state.webConfig.recordNum }}</a>
    </div>
  </div>
</template>

<script>
export default {
  name: "layout-footer",
  data() {
    return {

    }
  },
  computed: {
  },
  methods: {},
  created() {
  }
}
</script>

<style scoped lang="less">
#layout-footer {
  padding: 40px 0 0;
  color: rgba(231, 229, 228, 0.82);
  background: #1c1917;
  font-size: 13px;
}

a {
  text-decoration: none;
  color: rgba(231, 229, 228, 0.6);
  transition: color 0.2s;
}

.out-link:hover {
  color: #a8b5ac;
}

.footer-main {
  max-width: 900px;
  margin: 0 auto 32px auto;
  display: flex;
  justify-content: space-around;
  align-items: flex-start;
  padding: 0 20px;
}

.footer-item-title {
  font-size: 14px;
  font-weight: 700;
  color: #e7e5e4;
  margin-bottom: 14px;
  letter-spacing: 0.5px;
}

.footer-item div {
  margin-top: 10px;
  line-height: 1.8;
}

.footer-center {
  text-align: center;
}

.footer-logo {
  font-size: 20px;
  font-weight: 700;
  color: #a8b5ac;
  margin-bottom: 8px;
}

.footer-slogan {
  font-size: 12px;
  color: rgba(231, 229, 228, 0.35);
  letter-spacing: 1px;
}

.run-time {
  font-style: normal;
  background: rgba(74, 93, 79, 0.35);
  border: 1px solid rgba(74, 93, 79, 0.45);
  padding: 1px 8px;
  border-radius: 3px;
  font-size: 12px;
  color: #a8b5ac;
  font-weight: 500;
}

.online-count {
  font-style: normal;
  background: rgba(78, 158, 110, 0.3);
  border: 1px solid rgba(78, 158, 110, 0.4);
  padding: 1px 10px;
  border-radius: 3px;
  font-size: 12px;
  color: #8ec4a0;
  font-weight: 600;
}

.footer-divider {
  height: 1px;
  background: rgba(255, 255, 255, 0.05);
  margin: 0 40px;
}

.copyright {
  text-align: center;
  padding: 16px 20px;
  color: rgba(231, 229, 228, 0.32);
  font-size: 12px;
  line-height: 2;
}

.copyright a {
  color: rgba(231, 229, 228, 0.42);
  margin: 0 4px;
}

.copyright a:hover {
  color: #a8b5ac;
}
</style>
